// ns-location.js
(function () {
  // ---- EDIT THESE to match your SureCust field "name" attributes ----
  const FIELD = {
    gov: 'governorate',            // e.g. "governorate" or "ns_governorate"
    city: 'city',                  // e.g. "city" or "ns_city"
    govOther: 'governorate_other', // optional text input
    cityOther: 'city_other'        // optional text input
  };

  const JSON_URL = (window.NS_GOV_JSON_URL || '').trim();
  if (!JSON_URL) { console.warn('[NS] No NS_GOV_JSON_URL'); return; }

  // Try to find SureCust form root (main DOM or iframe)
  function getFormRoot() {
    // 1) main DOM (common if the app injects fields directly)
    const mainHas =
      document.querySelector(`[name="${FIELD.gov}"]`) &&
      document.querySelector(`[name="${FIELD.city}"]`);
    if (mainHas) return document;

    // 2) look for a SureCust iframe and use its document
    const iframes = Array.from(document.querySelectorAll('iframe'));
    const scIframe = iframes.find(f =>
      /surecust|form|app/i.test(f.src || '') ||
      (f.parentElement && /surecust|form/i.test(f.parentElement.className || ''))
    );
    if (scIframe) {
      try {
        const doc = scIframe.contentDocument || scIframe.contentWindow?.document;
        if (
          doc &&
          doc.querySelector(`[name="${FIELD.gov}"]`) &&
          doc.querySelector(`[name="${FIELD.city}"]`)
        ) {
          return doc;
        }
      } catch (e) {
        console.warn('[NS] Cannot access iframe content (cross-origin).');
      }
    }
    return null;
  }

  function qs(root, name) {
    return root.querySelector(`[name="${name}"]`);
  }

  function toggle(el, show) {
    if (!el) return;
    const wrap =
      el.closest('.form-group, .sc-form-group, .field, .field__input-wrapper, .grid, div') ||
      el;
    wrap.style.display = show ? '' : 'none';
  }

  function normalizeMap(data) {
    if (Array.isArray(data)) {
      const out = {};
      data.forEach(row => {
        if (row && row.governorate && Array.isArray(row.cities)) {
          out[row.governorate] = row.cities.slice();
        }
      });
      return out;
    }
    return (data && typeof data === 'object')
      ? JSON.parse(JSON.stringify(data))
      : {};
  }

  // Allow truly blank placeholder when placeholder === ''
  function fillSelect(select, values, placeholder) {
    if (!select) return;

    select.innerHTML = '';

    const ph = document.createElement('option');
    ph.value = '';

    // if placeholder is undefined/null → use "Select..."
    // if placeholder is '' → show completely blank text
    if (placeholder === undefined || placeholder === null) {
      ph.textContent = 'Select...';
    } else {
      ph.textContent = placeholder;
    }

    ph.disabled = true;
    ph.selected = true;
    select.appendChild(ph);

    (values || []).forEach(v => {
      const opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      select.appendChild(opt);
    });
  }

  function initOnce(root, map) {
    const govSelect = qs(root, FIELD.gov);
    const citySelect = qs(root, FIELD.city);
    const govOther  = qs(root, FIELD.govOther);
    const cityOther = qs(root, FIELD.cityOther);

    if (!govSelect || !citySelect) {
      console.warn('[NS] Fields not found. Check name attributes:', FIELD);
      return;
    }
    console.log('[NS] Fields found:', { govName: FIELD.gov, cityName: FIELD.city });

    // Build governorate list (sorted + "Other")
    const govs = Object.keys(map).sort();
    if (!govs.includes('Other')) govs.push('Other');

    // Initial state: **completely blank** text in both selects
    fillSelect(govSelect, govs, '');
    fillSelect(citySelect, [], '');

    toggle(govOther, false);
    toggle(cityOther, false);

    function handleGovChange() {
      const selGov = govSelect.value;
      const isOtherGov = selGov === 'Other';
      toggle(govOther, isOtherGov);

      let cities = [];
      if (selGov && map[selGov]) {
        cities = map[selGov].slice();
        if (!cities.includes('Other')) cities.push('Other');
      }

      // After a governorate is chosen, City gets a helpful placeholder
      fillSelect(
        citySelect,
        cities,
        cities.length ? 'Select City / Area' : 'Select Governorate first'
      );

      toggle(cityOther, citySelect.value === 'Other');
    }

    function handleCityChange() {
      toggle(cityOther, citySelect.value === 'Other');
    }

    // Prefill from customer metafields (optional)
    const pre = window.NS_PREFILL || {};
    if (pre.gov && govs.includes(pre.gov)) {
      govSelect.value = pre.gov;
      handleGovChange();
      if (pre.city && map[pre.gov]?.includes(pre.city)) {
        citySelect.value = pre.city;
        toggle(cityOther, citySelect.value === 'Other');
      }
    }

    govSelect.addEventListener('change', handleGovChange);
    citySelect.addEventListener('change', handleCityChange);

    // Guard: stop submit if not selected / missing "Other" text
    (root.defaultView || window).addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!form || !form.contains?.(govSelect)) return;

        if (govSelect.value === '') {
          e.preventDefault();
          govSelect.focus();
          return;
        }
        if (citySelect.value === '') {
          e.preventDefault();
          citySelect.focus();
          return;
        }
        if (govSelect.value === 'Other' && govOther && !govOther.value.trim()) {
          e.preventDefault();
          govOther.focus();
          return;
        }
        if (citySelect.value === 'Other' && cityOther && !cityOther.value.trim()) {
          e.preventDefault();
          cityOther.focus();
          return;
        }
      },
      true
    );
  }

  function boot() {
    // 1) fetch JSON
    fetch(JSON_URL)
      .then(r => r.json())
      .then(raw => {
        const map = normalizeMap(raw);
        if (!Object.keys(map).length) {
          console.warn('[NS] gov_cities.json loaded but empty/invalid.');
          return;
        }
        console.log('[NS] JSON loaded:', JSON_URL);

        // 2) try immediately
        const root = getFormRoot();
        if (root) {
          initOnce(root, map);
          return;
        }

        // 3) if not ready yet, observe until it appears
        const obs = new MutationObserver(() => {
          const r = getFormRoot();
          if (r) {
            obs.disconnect();
            initOnce(r, map);
          }
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
      })
      .catch(err => console.warn('[NS] Failed to load JSON', err));
  }

  // Don’t run inside the Theme Editor (some apps block)
  const inEditor = !!document.querySelector('html.shopify-design-mode, .shopify-design-mode');
  if (inEditor) {
    console.warn(
      '[NS] You are in Theme Editor; some app iframes block scripts here. Test on storefront.'
    );
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }
})();
